var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmDialog',{attrs:{"question":_vm.$t('delete.modal.question'),"icon":"$mdiDelete"},on:{"accept":_vm.remove}})}
var staticRenderFns = []

export { render, staticRenderFns }